/*
  input：字段值为string类型
  select：字段值为Array<object> 如[ {label: '', value: ''} ]
*/
const stepsDesc = [
  {
    action: 'addBlock',
    name: '',
    success: '',
    fail: '',
    params: {
      tips: '',
      source: {
        id: '',
        opcode: '',
        varName: [
          { label: '全部', value: '' },
          { label: '1', value: '111' },
          { label: '2', value: '222' }
        ],
        proccode: ''
      },
      target: {
        id: '',
        position: {
          x: '',
          y: ''
        },
        input: '',
        inputIndex: '',
        field: '',
        fieldIndex: ''
      }
    }
  },
  {
    action: 'change',
    name: '',
    success: '',
    fail: '',
    params: {
      name: '',
      newValue: '',
      oldValue: '',
      newValueDisplay: '',
      target: {
        id: '',
        input: '',
        inputIndex: 0
      }
    }
  },
  {
    action: 'clickElement',
    name: '',
    success: '',
    fail: '',
    params: {
      element: '',
      tips: ''
    }
  },
  {
    action: 'delay',
    name: '',
    success: '',
    fail: '',
    params: {
      ms: ''
    }
  },
  {
    action: 'dragBlock',
    name: '',
    success: '',
    fail: '',
    params: {
      tips: '',
      source: {
        id: '',
        opcode: '',
        varName: '',
        proccode: ''
      },
      target: {
        id: '',
        position: {
          x: '',
          y: ''
        },
        input: '',
        inputIndex: 0,
        field: '',
        fieldIndex: 0
      }
    }
  },
  {
    action: 'expectBlock',
    name: '',
    success: '',
    fail: '',
    params: {
      id: '',
      timeout: ''
    }
  },
  {
    action: 'expectPlayFinish',
    name: '',
    success: '',
    fail: '',
    params: {
      status: '',
      expectRunStop: [
        { label: '是', value: true },
        { label: '否', value: false }
      ]
    }
  },
  {
    action: 'focusElement',
    name: '',
    success: '',
    fail: '',
    params: {
      element: '',
      tips: '点击这里'
    }
  },
  {
    action: 'hideBlock',
    name: '',
    success: '',
    fail: '',
    params: {
      blockId: ''
    }
  },
  // {
  //   action: 'nextTask', // 暂时不需要
  //   name: '',
  //   success: '',
  //   fail: '',
  //   params: {
  //     taskId: ''
  //   }
  // },
  {
    action: 'removeBlock',
    name: '',
    success: '',
    fail: '',
    params: {
      tips: '',
      id: ''
    }
  },
  {
    action: 'restart',
    name: '',
    success: '',
    fail: '',
    params: {}
  },
  {
    action: 'run',
    name: '',
    success: '',
    fail: '',
    params: {
      tips: ''
    }
  },
  {
    action: 'setBlockId',
    name: '',
    success: '',
    fail: '',
    params: {
      originId: '',
      newId: ''
    }
  },
  {
    action: 'showMsg',
    name: '',
    success: '',
    fail: '',
    params: {
      title: '',
      msg: ''
    }
  },
  {
    action: 'switchGroup',
    name: '',
    success: '',
    fail: '',
    params: {
      // id: '',
      tips: '',
      categoryName: ''
    }
  }
  // {
  //   action: 'switchSprite', // 暂时不需要
  //   name: '',
  //   success: '',
  //   fail: '',
  //   params: {
  //     order: '',
  //     tips: ''
  //   }
  // }
]

const restParams = step => { // 解构source和target属性
  const params = Object.keys(step.params)
  const changeSource = params.includes('source')
  const changeTarget = params.includes('target')
  if (changeSource) {
    const i = params.indexOf('source')
    const tempS = Object.keys(step.params['source']).map(item => `source.${item}`)
    params.splice(i, 1, ...tempS)
  }
  if (changeTarget) {
    const i = params.indexOf('target')
    const tempT = Object.keys(step.params['target']).map(item => `target.${item}`)
    params.splice(i, 1, ...tempT)
    if(params.indexOf('target.position') > -1) {
      const j = params.indexOf('target.position')
      params.splice(j, 1, 'target.position.x', 'target.position.y')
    }
  }
  // const params = Object.keys(step.params).filter(item => item !=='source' && item !=='target' && item !=='expectRunStop')
  return { 
    action: step.action,
    name: step.name,
    success: step.success,
    fail: step.fail,
    params 
  }
}

const actionList = new Array(...new Set(stepsDesc.map(item => item.action)))
const stepList = actionList.map(action => {
  const tempStep = stepsDesc.find(step => step.action === action)
  return restParams(tempStep)
})
stepList.unshift({
  action: '',
  params: []
})

export {
  stepList as default,
  restParams,
  stepsDesc
}

